// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1LY5b","col":"styles_col__2wP9F"};